import type { GetMunicipalitiesResponse } from '@/types/Municipality.ts'
import { apiGet } from './ApiClient'

export async function getMunicipalities(): Promise<GetMunicipalitiesResponse> {
  return await apiGet<GetMunicipalitiesResponse>('/municipalities')
}
